import { useState } from 'react';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { selectPairs } from 'ducks/pairs/selectors';
import { Grid } from 'framework/Grid';
import { GridFieldCell } from 'framework/Grid/cells/GridCell';
import { GridColumn } from 'framework/Grid/columns/GridColumn';
import { Input } from 'framework/Input';
import { useAppSelector } from 'store/hooks';
import { filterGrid } from 'utils/strings';

import { Card } from 'components/cards/Card';
import { GridPairCell } from 'components/cells/GridPairCell';
import { GridPriceChipCell } from 'components/cells/GridPriceChipCell';
import { GridStatusChipCell } from 'components/cells/GridStatusChipCell';
import { GridAutoSizer } from 'components/grid/GridScrollable';

import cn from '../PairsPage.module.scss';

export const PairsGrid = () => {
  const voladeum_pairs = useAppSelector(selectPairs);
  const [filter, setFilter] = useState('');

  return (
    <Card>
      <div className={cn.grid}>
        <div className={cn.toolbar}>
          <h2>Pairs</h2>
          <Input
            left_icon={faSearch}
            value={filter}
            onChange={(input) => setFilter(input.value)}
            width="300px"
          />
        </div>
        <GridAutoSizer>
          <Grid rows={filterGrid(voladeum_pairs, filter)}>
            <GridColumn
              label="Pair"
              sort_field="pair_name"
              sort_direction="desc"
              width={150}
              text_align="left"
              fixed="left"
            >
              <GridPairCell />
            </GridColumn>
            <GridColumn label="Status" sort_field="status_name" fixed="left" width={125}>
              <GridStatusChipCell />
            </GridColumn>
            <GridColumn label="Adapter" sort_field="adapter_name" width={100} grow={1}>
              <GridFieldCell field="adapter_name" />
            </GridColumn>
            <GridColumn label="Price" sort_field="price" width={125}>
              <GridFieldCell field="price_formatted" />
            </GridColumn>
            <GridColumn label="Daily">
              <GridColumn label="Change" sort_field="price_change_pct" width={100}>
                <GridPriceChipCell />
              </GridColumn>
              <GridColumn label="High" sort_field="high" width={125}>
                <GridFieldCell field="high_formatted" />
              </GridColumn>
              <GridColumn label="Low" sort_field="low" width={125}>
                <GridFieldCell field="low_formatted" />
              </GridColumn>
              <GridColumn label="Volume" sort_field="volume" width={125}>
                <GridFieldCell field="volume_formatted" />
              </GridColumn>
            </GridColumn>
            <GridColumn label="Market Cap" sort_field="market_cap" width={150}>
              <GridFieldCell field="market_cap_formatted" />
            </GridColumn>
            <GridColumn label="Supply" sort_field="total_supply" width={150}>
              <GridFieldCell field="total_supply_formatted" />
            </GridColumn>
          </Grid>
        </GridAutoSizer>
      </div>
    </Card>
  );
};
